<template lang="pug">
div#app.app
  navbar
  div.app-body
    sidebar
    main.view-x.mt-3(role="main")
      router-view
    asidebar
</template>

<script>
import navbar from "@/components/navbar.vue";
import sidebar from "@/components/sidebar.vue";
import asidebar from "@/components/asidebar.vue";

export default {
  components: {
    navbar,
    sidebar,
    asidebar
  }
};
</script>

<style lang="scss" scoped>
</style>
